// extracted by mini-css-extract-plugin
export default {"container":"YqVDJ9qY","info":"g8c6kHVA","img":"qSfC55Lp"};